import MembershipTypeMaster from "../../masters/MembershipTypeMaster";
import DurationTypeMaster from "../../masters/DurationTypeMaster";
import FeeTypeMaster from "../../masters/FeeTypeMaster";

/**
 * Membership dashboard: type, duration, and fee master tables.
 * `onDirectoryChange` should refresh shared lookups (e.g. form + directory).
 */
export default function MembershipMastersSection({
  showMasters,
  onDirectoryChange,
  canCreate = false,
  canEdit = false,
  canDelete = false,
}) {
  if (!showMasters) return null;

  return (
    <div
      id="ms-masters"
      className="user-builder-panel"
      style={{ scrollMarginTop: "2rem" }}
    >
      <div className="user-builder-panel__head">
        <h3 className="user-builder-panel__title">Master Table Management</h3>
        <p className="user-builder-panel__hint">
          Configure core constraints and lookups.
        </p>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          marginTop: "2rem",
        }}
      >
        <div id="ms-type" style={{ scrollMarginTop: "2rem" }}>
          <MembershipTypeMaster
            onDirectoryChange={onDirectoryChange}
            canCreate={canCreate}
            canEdit={canEdit}
            canDelete={canDelete}
          />
        </div>
        <hr style={{ border: "0", borderTop: "1px solid #e5e7eb" }} />
        <div id="ms-duration" style={{ scrollMarginTop: "2rem" }}>
          <DurationTypeMaster
            onDirectoryChange={onDirectoryChange}
            canCreate={canCreate}
            canEdit={canEdit}
            canDelete={canDelete}
          />
        </div>
        <hr style={{ border: "0", borderTop: "1px solid #e5e7eb" }} />
        <div id="ms-fee" style={{ scrollMarginTop: "2rem" }}>
          <FeeTypeMaster
            onDirectoryChange={onDirectoryChange}
            canCreate={canCreate}
            canEdit={canEdit}
            canDelete={canDelete}
          />
        </div>
      </div>
    </div>
  );
}
